// extracted by mini-css-extract-plugin
export default {"HeroSection":"heroSection_HeroSection__HJhog","MainBanner":"heroSection_MainBanner__0Q98b","SubBanner":"heroSection_SubBanner__q2Obe","HeroImage":"heroSection_HeroImage__BhLM2"};